import { defineStore, acceptHMRUpdate } from 'pinia'
import type { Agent, Message, ChatSession } from '@/types'

interface ChatState {
  sessions: ChatSession[]
  currentSessionId: string | null
  agents: Agent[]
}

export const useChatStore = defineStore('chat', {
  state: (): ChatState => ({
    sessions: [],
    currentSessionId: null,
    agents: [
      {
        id: 'safety-officer',
        name: '安全官',
        role: 'Safety Officer',
        avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCgRGe1YvFJp_iVJBW_I-Z-25r-gDNMmGtqCfxWVxVeK6_bS5lyJ9Ym2gdzcYexoozmkejrcgINC-CiONqJPav_EjhQtYV8McnIWwWM1p1lqeesMQdCLAmdLvHmP2kihyKjA2R0PA3arDaP-i5E9b1WVUwJZxrxFxyrP8UIJ7nQTlZHdvAQMpmf8Sr8XWHzhtsEe3L0sNuziSpZMV_w9KNlYGaryx6DRne_JEOwCjm60zpXItzIbgNQpzrbeTkUSL4qWwUzo3pLJ7w',
        specialty: ['工业安全', '职业健康', '应急管理', '风险评估'],
        status: 'online'
      },
      {
        id: 'energy-analyst',
        name: '能源分析师',
        role: 'Energy Analyst',
        avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCaEQXylxjPrGfC5bgI7jZcj12VufGOv5o4Jn56k87xbP0KC3YAYTRYG4yPa5JWyOGSaBhbvwL2HO8WQQZVFLErAx4OCiwGawxJ_cvn7hF9xNrRhysrzULK8GO7kbOOMVoU9nWNOtpJ7fiHA59tKZD0WdZ4vTLL6nGvhIS1DKBqqQjZbQFTAypQzPW0GLVFK8r1fuhO_fL0bqC8qHQ0bKeDdOSCIaJZgJxdwglxsMEJhskMe8DHY7YGg4BUeZ2nIJO0PKR6COkzGYM',
        specialty: ['能效分析', '节能改造', '可再生能源', '能源管理'],
        status: 'online'
      },
      {
        id: 'carbon-expert',
        name: '碳管理专家',
        role: 'Carbon Management Expert',
        avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDlu4PNHAZnIvvXL8A7kOQVQAft1uznqhAiRdgQcvqJ28_hsSWIJ09HKdiKJKSLlA-pBIcnL9Wt8O8GuDIdm64rbNJ7yXPM2hezVVZj9aIMockWWtFHi5Fcoo20WnTqVJAPOi18nEF-7RoWWdunsy5fK1pT2o3X572ldOpJAbz8wz_-ojqzoZ0Iukq3c9qC1TA41T3-hAj41CyWBjpJM-aESxd_ljoiuRERs-3U_4C7zUNO9ChVUpGsnHZp_pD5ml30i7nDVfk8xRM',
        specialty: ['碳足迹', '碳核算', '碳交易', '减排策略'],
        status: 'online'
      }
    ]
  }),

  getters: {
    currentSession: (state): ChatSession | null => {
      return state.sessions.find(s => s.id === state.currentSessionId) || null
    },

    getAgentById: (state) => (id: string): Agent | undefined => {
      return state.agents.find(agent => agent.id === id)
    }
  },

  actions: {
    createSession(title: string, agentIds: string[] = []): ChatSession {
      const selectedAgents = agentIds.length > 0 
        ? this.agents.filter(agent => agentIds.includes(agent.id))
        : this.agents

      const session: ChatSession = {
        id: `session-${Date.now()}`,
        title,
        agents: selectedAgents,
        messages: [],
        status: 'active',
        createdAt: Date.now(),
        updatedAt: Date.now()
      }

      this.sessions.push(session)
      this.currentSessionId = session.id
      return session
    },

    addMessage(message: Message) {
      const session = this.currentSession
      if (session) {
        session.messages.push(message)
        session.updatedAt = Date.now()
      }
    },

    setCurrentSession(sessionId: string) {
      this.currentSessionId = sessionId
    },

    initializeDefaultSession() {
      if (this.sessions.length === 0) {
        this.createSession('制造工厂安全审核', ['safety-officer', 'energy-analyst'])
      }
    }
  }
})

// 启用Pinia Store的热重载支持
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useChatStore, import.meta.hot))
}